/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { UserOutlined } from "@ant-design/icons";

const MenuItemCard = (props) => {

    const {
        selectedIndex,
        index,
        onClick,
        primary,
        component,
        to,
    } = props || {};

    const handleOnClick = () => {
        onClick(selectedIndex);
    };

    return (
        <ListItemButton
            selected={selectedIndex === index}
            onClick={handleOnClick}
            component={component}
            to={to}
        >
            <ListItemIcon>
                <UserOutlined />
            </ListItemIcon>
            <ListItemText primary={primary} />
        </ListItemButton>
    );
};

export { MenuItemCard };
